import { useInfiniteQuery } from '@tanstack/react-query';
import { get } from '../api/api';
import { API_URLS } from '../constants/apiUrl';
import { QueryParamObject, toQueryString } from '../constants/utilityFunctions';
interface IUseFetchPrivateMatterRequests {
  relations?: string[];
  sortBy?: string[];
  extraFilters?: Record<string, string | number>;
  limit?: number;
  search?: string;
  customerId?: string;
  fields?: string[];
}
export const useFetchPrivateMatterRequests = (params: IUseFetchPrivateMatterRequests) => {
  const fetchPrivateMatterRequests = async ({ pageParam = 1 }) => {
    const {
      relations: matterRequestRelations,
      customerId,
      extraFilters: filters,
      ...rest
    } = params;
    const queryString = new URLSearchParams(
      Object.keys(rest)?.length ? toQueryString(rest as QueryParamObject) : '',
    );

    Object.entries(filters ?? {}).forEach(([key, value]) => {
      queryString.append(`filter.${key}`, String(value));
    });

    (matterRequestRelations ?? []).forEach((rel) => queryString.append('relations', rel));

    queryString.append('page', String(pageParam));
    try {
      return await get(
        `${API_URLS.PRIVATE_PERSON_MATTER_REQUESTS.replace(':id', String(customerId))}?${queryString.toString()}`,
      );
    } catch (error) {
      console.error('Error fetching private matter requests:', error);
      throw new Error(
        (error as { message: string }).message || 'Failed to fetch private matter requests',
      );
    }
  };

  const {
    data,
    isLoading,
    error,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    refetch,
    isFetching,
  } = useInfiniteQuery({
    initialPageParam: 1,
    queryKey: ['private-matter-requests', params],
    queryFn: fetchPrivateMatterRequests,
    getNextPageParam: (lastPage, allPages) => {
      const totalCount = lastPage?.meta?.totalItems ?? 0;
      const fetchedCount = allPages.flatMap((page) => page.data).length;
      return fetchedCount < totalCount ? allPages.length + 1 : undefined;
    },
  });
  return {
    data: data?.pages.flatMap((page) => page.data) ?? [],
    isLoading,
    error,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    refetch,
    isFetching,
  };
};
